import React from "react"
import styled from "styled-components"
import { P } from "styleguide/components/Text"
import { uiColorToBaseColor } from "styleguide/styles/colors"
import media from "styleguide/styles/media-queries"

interface Props {
  className?: string
  heading: React.ReactNode
  body: React.ReactNode
  iconClose?: React.ReactNode
  iconOpen?: React.ReactNode
}

const StyledWrapper = styled.div`
  border-radius: 8px;
  display: inline-block;
  border: 2px solid ${uiColorToBaseColor("black")};
  padding: 32px;
  max-width: 448px;
  flex: 1;

  &:hover {
    cursor: pointer;
  }

  &:first-of-type {
    margin-right: 32px;
  }

  ${media.tablet`
    padding: 24px;
    width: 100%;
    margin-right: 0;
    margin-bottom: 16px;
    max-width: calc(100% - 54px);
  `}
`

const HeadingWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  cursor: pointer;
`

const StyledHeading = styled(P)`
  color: ${uiColorToBaseColor("red")};
  font-weight: 600;
  margin: 0;
`

const StyledBodyText = styled(P)`
  color: ${uiColorToBaseColor("darkestGray")};
  margin-bottom: 0;
  line-height: 24px;
  margin-top: 16px;
  white-space: pre-line;
`

const StyledIcon = styled(({ icon, ...props }) =>
  React.cloneElement(icon, props)
)`
  width: 16px;
  height: 16px;
  min-width: 16px;
`

const CollapsibleDropdown = (props: Props) => {
  const { heading, body, iconClose, iconOpen } = props
  const [isOpen, setIsOpen] = React.useState(false)
  const toggleCollapse = () => setIsOpen(!isOpen)

  return (
    <StyledWrapper onClick={toggleCollapse} className={props.className}>
      <HeadingWrapper>
        <StyledHeading>{heading}</StyledHeading>
        <StyledIcon icon={isOpen ? iconOpen : iconClose} />
      </HeadingWrapper>
      {isOpen && (
        <StyledBodyText dangerouslySetInnerHTML={{ __html: body }} size="M" />
      )}
    </StyledWrapper>
  )
}

export default CollapsibleDropdown
